<template>
  <svg
    width="111"
    height="41"
    viewBox="0 0 111 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_15458_30701)">
      <mask
        id="mask0_15458_30701"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="110"
        height="41"
      >
        <path
          d="M110 0.5H0V40.5H110V0.5Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_15458_30701)">
        <path
          d="M40.5469 19.6941C40.5534 18.4205 41.3217 17.6744 42.4414 17.6744C43.5548 17.6744 44.2253 18.3947 44.2188 19.604V25.4059H46.9923V19.1152C46.9923 16.8125 45.6251 15.3974 43.5418 15.3974C42.0574 15.3974 40.9832 16.1178 40.534 17.2691H40.4168V15.5261H37.7736V25.4059H40.5469V19.6941Z"
          fill="white"
        />
        <path
          d="M53.7361 25.5989C56.2101 25.5989 57.8767 24.4089 58.2674 22.5758L55.7022 22.4085C55.4223 23.1611 54.7062 23.5534 53.7817 23.5534C52.3949 23.5534 51.5161 22.6464 51.5161 21.1735V21.1671H58.326V20.4145C58.326 17.0569 56.2687 15.3974 53.6254 15.3974C50.6828 15.3974 48.7751 17.4621 48.7751 20.511C48.7751 23.6435 50.6567 25.5989 53.7361 25.5989ZM51.5161 19.4689C51.5747 18.3433 52.4405 17.4429 53.671 17.4429C54.8755 17.4429 55.7087 18.2919 55.7153 19.4689H51.5161Z"
          fill="white"
        />
        <path
          d="M66.5483 21.1989C66.5548 22.5239 65.6369 23.2186 64.6408 23.2186C63.5925 23.2186 62.9155 22.4918 62.909 21.3275V15.5257H60.1356V21.8163C60.142 24.1256 61.5092 25.5342 63.521 25.5342C65.0249 25.5342 66.1056 24.7688 66.5548 23.611H66.6589V25.4056H69.3217V15.5257H66.5483V21.1989Z"
          fill="white"
        />
        <path
          d="M71.5403 25.4054H74.3137V19.8157C74.3137 18.6 75.2122 17.7639 76.4358 17.7639C76.8201 17.7639 77.3478 17.8281 77.6084 17.9118V15.4803C77.3609 15.4225 77.0156 15.3839 76.7353 15.3839C75.6158 15.3839 74.6979 16.0272 74.3332 17.2493H74.2291V15.5255H71.5403V25.4054Z"
          fill="white"
        />
        <path
          d="M83.0937 25.5989C86.1279 25.5989 88.0154 23.547 88.0154 20.5046C88.0154 17.4429 86.1279 15.3974 83.0937 15.3974C80.0595 15.3974 78.172 17.4429 78.172 20.5046C78.172 23.547 80.0595 25.5989 83.0937 25.5989ZM83.1067 23.4762C81.7072 23.4762 80.9907 22.2091 80.9907 20.4853C80.9907 18.7614 81.7072 17.4878 83.1067 17.4878C84.4801 17.4878 85.1967 18.7614 85.1967 20.4853C85.1967 22.2091 84.4801 23.4762 83.1067 23.4762Z"
          fill="white"
        />
        <path
          d="M92.5935 19.6941C92.5996 18.4205 93.3681 17.6744 94.4879 17.6744C95.601 17.6744 96.2716 18.3947 96.2655 19.604V25.4059H99.0385V19.1152C99.0385 16.8125 97.671 15.3974 95.5879 15.3974C94.1037 15.3974 93.0296 16.1178 92.5805 17.2691H92.4629V15.5261H89.8198V25.4059H92.5935V19.6941Z"
          fill="white"
        />
        <path
          d="M109.545 18.3433C109.298 16.523 107.814 15.3974 105.287 15.3974C102.728 15.3974 101.042 16.568 101.049 18.472C101.042 19.9513 101.987 20.9098 103.94 21.2958L105.672 21.6367C106.544 21.8103 106.941 22.1255 106.954 22.6207C106.941 23.2061 106.296 23.6242 105.326 23.6242C104.337 23.6242 103.679 23.2061 103.51 22.4021L100.782 22.5435C101.042 24.4346 102.67 25.5989 105.32 25.5989C107.911 25.5989 109.767 24.2931 109.773 22.3442C109.767 20.9162 108.823 20.0607 106.882 19.6683L105.073 19.3081C104.141 19.1087 103.796 18.7936 103.803 18.3176C103.796 17.7258 104.474 17.3399 105.333 17.3399C106.296 17.3399 106.869 17.8609 107.006 18.4977L109.545 18.3433Z"
          fill="white"
        />
        <path
          d="M0.494298 1.19566C2.82053 0.843465 5.16393 0.612843 7.51477 0.504752C10.4134 0.443443 13.04 0.961033 14.9314 2.89581C18.4649 6.51657 18.5294 11.3258 18.5842 13.336C18.584 14.2137 18.8947 15.0639 19.4626 15.7389C20.1977 16.7541 20.4912 17.0794 21.3719 18.3433C22.1643 19.4705 22.2872 20.0552 21.1618 20.7014C20.0366 21.3474 20.0569 21.5443 20.3265 22.0373C20.5566 22.3912 20.6679 22.8077 20.645 23.2277C20.6221 23.6478 20.4661 24.0501 20.1989 24.3776C20.7633 25.6014 19.6845 25.8501 20.0653 26.8145C20.4458 27.779 20.4232 28.819 19.397 29.5016C18.3707 30.1842 17.212 30.1264 15.1928 30.1111C13.1736 30.0958 12.201 30.0853 12.4683 32.3394C12.7357 34.5937 12.6843 37.1841 11.306 38.4338C9.92773 39.6835 8.70093 39.6883 7.77013 39.4136C6.83934 39.1389 6.88706 39.5704 5.7152 40.0985C4.54333 40.6267 3.23184 40.3733 3.23781 39.8805C3.23781 39.6977 3.40726 39.5963 3.66383 39.1801C4.6913 37.5448 4.17817 34.8791 3.8488 32.9243C3.47409 30.4661 4.66147 30.7714 6.61379 30.6087C8.00387 30.559 9.37376 30.2648 10.6592 29.7397C11.6867 29.2328 11.5483 28.273 11.2141 27.3534C10.7511 26.1248 11.6819 25.7027 10.5972 24.5143C11.3013 23.5451 11.1115 23.0477 10.818 22.5855C10.423 21.9559 10.2535 21.1635 11.4146 20.6448C12.6939 20.0765 12.8323 19.8831 11.9946 18.8374C11.059 17.6701 10.6378 17.3141 9.86211 16.3614C9.2248 15.575 8.57687 14.8086 8.49453 13.7522C8.29995 11.2432 7.81069 6.7795 4.38343 3.86496C3.40325 3.09286 2.22304 2.60872 0.977602 2.46782C0.252048 2.34048 -0.00929546 2.21905 0.000251288 1.76041C0.00979809 1.30177 0.236535 1.22513 0.494298 1.19566Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_15458_30701">
        <rect
          width="110.857"
          height="40"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
